@let local_show_card = showCard();
@let local_last_opened_item = level();
@let local_card_story_content = cardStoryContent();
@let local_show_story_content = showStoryContent();

<div
  class="modal-container tw-relative tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-overflow-hidden"
  [class.card-stage-active]="local_show_card"
  [class.story-layout-active]="local_show_story_content"
  [class.story-available]="!!local_card_story_content"
>
  <app-ui-button
    class="ghost gray-color tw-absolute tw-right-[1rem] tw-top-[1rem] tw-z-10 !tw-size-[1rem] tb:tw-right-[1.5rem] tb:tw-top-[1.5rem]"
    [style.--button__padding-x]="'0'"
    [style.--button__padding-y]="'0'"
    (buttonClick)="close()"
  >
    <mat-icon
      svgIcon="close"
      class="!tw-size-[1.5rem] tw-text-[#728188] lp:!tw-size-[2rem]"
    />
  </app-ui-button>

  <div class="modal-content tw-relative tw-flex tw-max-w-5xl -tw-translate-y-[5%] tw-flex-col tw-items-center tw-justify-center tw-p-4">
    @if (showZipPack()) {
      <app-zip-pack-animation
        #zipPackAnimation
        class="zip-pack tw-flex tw-h-full tw-items-center tw-justify-center max-lg:tw-max-w-5xl max-md:tw-w-[55rem]"
        [animationPath]="zipAnimationPath"
        [useBinarySkeleton]="false"
        [packSkin]="zipPackSkin()"
        [packSkinPrefixes]="zipPackSkinPrefixes"
        [glowSkin]="glowSkin()"
        [buttonText]="'EVENT.ICE_BREAKERS_EVENT.OPEN_THE_PACK' | translate"
        [class.animating-out]="zipPackAnimatingOut()"
        (packOpened)="onPackOpened()"
        (buttonClick)="openPack()"
        (holdStarted)="onHoldStarted()"
        (tearProgress)="onTearProgress($event)"
        (tearFinished)="onTearFinished()"
      />
    }
    @if (local_show_card && local_last_opened_item) {
      <div class="result-layout">
        <div class="gradient-text progress-counter tw-text-[2rem] tw-font-bold">{{ step() }} / {{ totalSteps }}</div>

        <div
          class="result-stage"
          [class.story-layout]="local_show_story_content"
          [class.story-available]="!!local_card_story_content"
        >
          <div class="card-column">
            <app-holo-card
              class="holo-card"
              [class.show]="showCard()"
              [style.--back-caption-shift-y]="'-0.75rem'"
              [level]="local_last_opened_item"
              [disableHoverFlip]="true"
              [(isFlipped)]="isCardFlipped"
            />
          </div>

          @if (local_card_story_content) {
            <div
              class="story-column"
              [class.show]="local_show_story_content"
            >
              <h2 class="story-title">{{ local_card_story_content.titleKey | translate }}</h2>
              <p class="story-description">{{ local_card_story_content.descriptionKey | translate }}</p>
            </div>
          }
        </div>

        <app-event-button
          class="action-button tw-min-w-64"
          [width]="'100%'"
          (click)="onCardButtonClick()"
        >
          @if (viewOnly()) {
            {{ 'CLOSE' | translate }}
          } @else if (isCardFlipped()) {
            {{ 'EVENT.ICE_BREAKERS_EVENT.COLLECT' | translate }}
          } @else {
            {{ 'EVENT.ICE_BREAKERS_EVENT.FLIP_CARD' | translate }}
          }
        </app-event-button>
      </div>
    }
  </div>
</div>
